import type { CommonAddress } from '@wix/ambassador-wix-atlas-service-web/types';
import type { CountryCode } from '@wix/form-multiline-address';

export enum ADDRESS_TARGETS {
  COUNTRY = 'country',
  SUBDIVISION = 'subdivision',
  CITY = 'city',
  ADDRESS_LINE = 'addressLine',
  ADDRESS_LINE_2 = 'addressLine2',
  POSTAL_CODE = 'postalCode',
  STREET_NAME = 'streetName',
  STREET_NUMBER = 'streetNumber',
  APARTMENT = 'apartment',
}

export type AddressCamel = {
  [ADDRESS_TARGETS.COUNTRY]?: CountryCode;
  [ADDRESS_TARGETS.SUBDIVISION]?: string;
  [ADDRESS_TARGETS.CITY]?: string;
  [ADDRESS_TARGETS.ADDRESS_LINE]?: string;
  [ADDRESS_TARGETS.ADDRESS_LINE_2]?: string;
  [ADDRESS_TARGETS.POSTAL_CODE]?: string;
  [ADDRESS_TARGETS.STREET_NAME]?: string;
  [ADDRESS_TARGETS.STREET_NUMBER]?: string;
  [ADDRESS_TARGETS.APARTMENT]?: string;
};

export type Address = {
  country?: CountryCode;
  subdivision?: string;
  city?: string;
  address_line?: string;
  address_line_2?: string;
  postal_code?: string;
  street_name?: string;
  street_number?: string;
  apartment?: string;
};

export function fromAtlasAddress(
  address: CommonAddress,
  isMultilineAddressField: boolean,
): Address {
  const {
    country,
    subdivision,
    city,
    addressLine,
    streetAddress,
    addressLine2,
    postalCode,
  } = address;

  const partial: AddressCamel & Address = {};

  if (isMultilineAddressField) {
    if (country) {
      partial.country = country as CountryCode;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }

    if (addressLine) {
      partial.addressLine = addressLine;
    } else if (streetAddress?.formattedAddressLine) {
      partial.addressLine = streetAddress?.formattedAddressLine;
    }

    if (addressLine2) {
      partial.addressLine = addressLine2;
    }
    if (postalCode) {
      partial.postalCode = postalCode;
    }
    if (streetAddress?.apt) {
      partial.apartment = streetAddress?.apt;
    }
    if (streetAddress?.name) {
      partial.streetName = streetAddress?.name;
    }
    if (streetAddress?.number) {
      partial.streetNumber = streetAddress.number;
    }
  } else {
    if (country) {
      partial.country = country as CountryCode;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }

    if (addressLine) {
      partial.address_line = addressLine;
    } else if (streetAddress?.formattedAddressLine) {
      partial.address_line = streetAddress?.formattedAddressLine;
    }

    if (addressLine2) {
      partial.address_line = addressLine2;
    }
    if (postalCode) {
      partial.postal_code = postalCode;
    }
    if (streetAddress?.apt) {
      partial.apartment = streetAddress?.apt;
    }
    if (streetAddress?.name) {
      partial.street_name = streetAddress?.name;
    }
    if (streetAddress?.number) {
      partial.street_number = streetAddress.number;
    }
  }

  return partial;
}
